module.exports = __webpack_public_path__ + "datahub/img/international.256537bf.svg";